<template>
    <div class="upload">
        <van-field :name="attr.name" v-model="value" :rules="[
              {
                required: attr.required ,
                message: attr.message,
              },
            ]">
            <template #input>
                <div class="avatar-wrap">
                    <div class="label" :class="{'label-require':attr.required}">{{attr.title}}</div>
                    <div class="img-box">
                        <div class="img-view" v-if="url">
                            <img :src="url" alt />
                        </div>

                        <div class="upload-box" @click="onSelectUpload">
                            <img :src="img" alt="">

                        </div>
                    </div>
                </div>
            </template>
        </van-field>

        <input class="avatar-input" style="display:none;" type="file" accept="image/*" ref="camera" capture="camera" @change="fileChange" />
        <input class="avatar-input" style="display:none;" type="file" accept="image/*" ref="files" @change="fileChange" />

        <van-popup v-model="showUploadType" position="bottom">
            <div class="upload-before">

                <div class="action">
                    <div class="action-btn" @click="onSelect('拍照')">拍照</div>
                    <div class="action-btn" @click="onSelect('文件')">从相册上传</div>
                    <div class="action-btn" @click="showUploadType = false">取消</div>
                </div>

            </div>

        </van-popup>
    </div>
</template>

<script>
import httpRequest from '@/module_visitor/api/http.js';
import Toast from 'vant/lib/toast';
export default {
    props: {
        attr: {
            type: Object,
            default: () => {
                return {};
            },
        },
        value: {
            type: String,
        },
    },
    data() {
        return {
            img: require('../../assets/img/upload_f.png'),
            fileName: '',
            url: '',
            showUploadType: false,
        };
    },
    watch: {},
    components: {},
    methods: {
        // 选择文件
        fileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            var file = files[0];

            this.handleUploadImg(file);
        },

        // 上传图片
        handleUploadImg(file) {
            let formData = new FormData();
            formData.append('file', file);

            Toast.loading({
                message: '上传中...',
                forbidClick: true,
                loadingType: 'spinner',
            });
            httpRequest
                .post(`/api/visitor/upload`, formData, true)
                .then(res => {
                    console.log('🚀 ~ handleUploadImg ~ res:', res);
                    if (res.data.code == 200) {
                        this.url = res.data.data.url;
                        this.$emit('input', res.data.data.url);
                    }
                })

                .catch(error => {})
                .finally(() => {
                    Toast.clear();
                });
        },
        onSelectUpload() {
            this.showUploadType = true;
        },
        onSelect(value) {
            this.showUploadType = false;
            this.filesType = value;
            if (value == '拍照') {
                this.$refs.camera.click();
            } else if (value == '文件') {
                this.$refs.files.click();
            }
        },
        onCancel() {
            this.showUploadType = false;
        },
    },
    created() {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
.upload {
    position: relative;
    background: #fff;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    padding: 5px 0;
    .avatar-wrap {
        .label {
            font-size: 14px;
            color: #333;
            font-weight: bold;
            position: relative;
        }
        .label-require {
        }
        .img-box {
            display: flex;
            .img-view {
                width: 80px;
                height: 80px;
                border-radius: 8px;
                overflow: hidden;
                margin-right: 4px;
                img {
                    width: auto;
                    height: 80px;
                }
            }
            .upload-box {
                position: relative;
                width: 80px;
                height: 80px;
                background: #f7f8fa;
                border-radius: 5px;
                font-size: 60px;
                color: #ddd;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 100%;
                    height: 100%;
                }
                .img-input {
                    opacity: 0;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
        }

        .label-require::before {
            position: absolute;
            left: -8px;
            color: #ee0a24;
            font-size: 14px;
            content: '*';
        }
    }
    .avatar-input {
    }
    .upload-before {
        display: flex;

        flex-direction: column;
        padding: 12px;
        .example-img {
            img {
                width: 100%;
            }
        }
        .action {
            background: #fff;
            border-radius: 10px;
            .action-btn {
                height: 50px;
                line-height: 50px;
                padding: 0 16px;
                text-align: center;
                border-bottom: 1px solid #eaeaea;
            }
            .action-btn:nth-of-type(3) {
                border-bottom: none;
            }
        }
    }

    .file-name {
        padding: 5px 20px;
    }
}
</style> 